<h2 class="content-block"><i class="fa-solid fa-calendar-days"></i> Olay Günlüğü</h2>
 <div id="container">
  <div class="content">
        <div class="content-block card responsive-paddings wide-card dx-widget dx-visibility-change-handler">
      <dx-data-grid
        #dataGrid1
        class="dx-datagrid dx-gridbase-container"
        [dataSource]="dataSource"
        [focusedRowEnabled]="true"
        [focusedRowIndex]="0"
        (onRowClick)="rowClick($event)"
      >
        <dxo-export [enabled]="false"></dxo-export>
        <dxi-column
          dataField="rowNumber"
          [caption]="'#'"
          cellTemplate="rowNumberTemplate"
          [width]="50"
          [allowFiltering]="false"
        >
        </dxi-column>
        <dxo-export [enabled]="false"></dxo-export>
        <dxi-column dataField="userId" caption="Kullanıcı">
          <dxo-lookup
            [dataSource]="users"
            valueExpr="id"
            displayExpr="name"
          ></dxo-lookup>
        </dxi-column>
        <dxi-column
          dataField="createdDate"
          dataType="datetime"
          format="dd.MM.yyyy HH:mm"
          caption="Tarih"
        ></dxi-column>
        <dxi-column dataField="description" caption="Açıklama"></dxi-column>
        <dxi-column dataField="httpType" caption="Http Type">
          <dxo-lookup
            [dataSource]="httpTypes"
            valueExpr="id"
            displayExpr="name"
          ></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="processUrl" caption="Api Url"></dxi-column>
        <dxi-column dataField="ipAddress" caption="IP"></dxi-column>
        <dxi-column dataField="category" caption="Kategori">
          <dxo-lookup
            [dataSource]="categories"
            valueExpr="id"
            displayExpr="name"
          ></dxo-lookup>
        </dxi-column>
        <div
          *dxTemplate="let cellInfo of 'rowNumberTemplate'"
          class="name-template"
        >
          <div>
            {{ getRowNumber(cellInfo.rowIndex) }}
          </div>
        </div>
      </dx-data-grid>
    </div>
    <app-eventlog-detail
      [selectedEventLog]="selectedEventLog"
      [(isOpened)]="popupVisible"
    >
    </app-eventlog-detail>
  </div>
</div>
